import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { setupDigitNormalization } from "./utils/digits";

// توحيد الأرقام: تحويل أي أرقام هندية/فارسية راجعة من السيرفر إلى غربية قبل العرض
setupDigitNormalization();

AOS.init();
const root = ReactDOM.createRoot(document.getElementById("root"));
// Light theme only — dark mode removed by design
document.documentElement.classList.remove("dark");

// 🧹 إخفاء كل رسائل الكونسول في وضع الإنتاج فقط
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

// ✅ تسجيل الـ Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => {
        // تم التسجيل بنجاح (بدون طباعة في الكونسول)
      })
      .catch(() => {
        // فشل التسجيل (بدون طباعة في الكونسول)
      });
  });
}
